import { PDFJS_DIST_FALLBACK_VERSION } from "./pdfjsDistFallbackVersion";

type PdfJsWorkerHost = {
  version?: string;
  GlobalWorkerOptions?: {
    workerSrc: string;
  };
};

export const getPdfJsWorkerSrc = (pdfjsLib: PdfJsWorkerHost | null | undefined): string => {
  const version = pdfjsLib?.version || PDFJS_DIST_FALLBACK_VERSION;
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/legacy/build/pdf.worker.min.mjs`;
};

export const configurePdfJsWorker = (pdfjsLib: PdfJsWorkerHost | null | undefined): void => {
  if (!pdfjsLib?.GlobalWorkerOptions) return;
  const workerSrc = getPdfJsWorkerSrc(pdfjsLib);
  if (pdfjsLib.GlobalWorkerOptions.workerSrc !== workerSrc) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
  }
};
